module.exports = __webpack_public_path__ + "static/img/hlxd_logo.e35561e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hlxd_logo.png
// module id = XpaY
// module chunks = 1